import React from "react";
import { connect } from "react-redux";
import { isEmptyArray, isFull } from '../../common/utils';
import WithAuth from "../Auth/WithAuth";
import { retrieveSessionStorage } from "../../common/storageUtils";
import { Application } from "../../common/constants";
import {
    setActiveAppSpaceId,
    setActiveOrganisationId
} from '../../store/reducers/organisationService';
import { setActiveTenantId } from '../../store/reducers/tenantService';
import { checkUserPermission, fetchGrantedClaims } from "../../services/business/accessService";

export default function WithOrganisations(WrappedComponent, options) {
    class WithOrganisationsHoC extends React.Component {
        getActiveOrganisation = () => {
            let allMyOrgs = retrieveSessionStorage(Application.StorageKeys.MyOrganisations);
            if (isEmptyArray(allMyOrgs)) {
                return undefined;
            }
            let activeOrg = allMyOrgs.filter(o => o.id === this.props.organisations?.activeOrganisationId)[0];
            return activeOrg;
        }

        getActiveAppSpace = () => {
            let allMyOrgs = retrieveSessionStorage(Application.StorageKeys.MyOrganisations);

            if (isEmptyArray(allMyOrgs)) {
                return undefined;
            }
            let activeOrg = allMyOrgs?.filter(o => o.id === this.props.organisations?.activeOrganisationId)[0];
            let appSpace = activeOrg?.appSpaces?.filter(appSpace => appSpace.id === this.props.organisations?.activeAppSpaceId)[0]
            return appSpace;
        }

        getActiveTenant = () => {
            let allMyTenants = retrieveSessionStorage(Application.StorageKeys.MyTenants);
            if (isEmptyArray(allMyTenants)) {
                return undefined;
            }
            let activeTenant = allMyTenants.filter(o => o.id === this.props.tenants?.activeTenantId)[0];
            return activeTenant;
        }

        setActiveAppSpaceId = (appSpaceId) => {
            this.props.setActiveAppSpaceId(appSpaceId);
        }

        setActiveOrganisationId = (orgId) => {
            this.props.setActiveOrganisationId(orgId);
        }

        ///
        ///To refresh the dashboard with the latest assets created in the AppSpace
        ///
        getOrganisations = () => {
            let allMyOrgs = retrieveSessionStorage(Application.StorageKeys.MyOrganisations);
            return allMyOrgs;
        };

        getTenants = () => {
            let allMyTenants = retrieveSessionStorage(Application.StorageKeys.MyTenants);
            return allMyTenants
        };

        canUserPerform = async ({
            requiredClaim,
            userId = this.props.user.userId,
            productId,
            appSpaceId = this.props.organisations?.activeAppSpaceId,
            organisationId = this.props.organisations?.activeOrganisationId,
            tenantId = this.props.tenants?.activeTenantId,
            targetResourceType }) => {

            var result = await checkUserPermission({
                userId,
                permissionCheckRequestData: {
                    userId,
                    appSpaceId,
                    organisationId,
                    tenantId,
                    requiredClaim,
                    productId,
                    targetResourceType
                },
                accessToken: this.props.accessToken,
                refreshToken: this.props.refreshToken
            });

            return result;
        };

        // Bulk sibling of canUserPerform: checks a list of claims in one Access
        // API call and answers true when any of them is granted. Same context
        // defaulting as canUserPerform.
        //
        // Accepts a grant from the catalogue (common/identity/grants.js), which
        // supplies both the claims and the resource type, or a raw claim array:
        //   canUserPerformAny({ grant: AppSpaceGrantCatalogue.canEditSettings })
        //   canUserPerformAny({ candidateClaims: [...], targetResourceType: ... })
        canUserPerformAny = async ({
            candidateClaims,
            grant,
            userId = this.props.user.userId,
            productId,
            appSpaceId = this.props.organisations?.activeAppSpaceId,
            organisationId = this.props.organisations?.activeOrganisationId,
            tenantId = this.props.tenants?.activeTenantId,
            targetResourceType = grant?.targetResourceType }) => {

            var grantedClaims = await fetchGrantedClaims({
                userId,
                candidateClaims: candidateClaims ?? grant?.claims ?? [],
                productId,
                appSpaceId,
                organisationId,
                tenantId,
                targetResourceType,
                accessToken: this.props.accessToken,
                refreshToken: this.props.refreshToken
            });

            return grantedClaims.length > 0;
        };

        render() {
            return <WrappedComponent
                activeOrganisation={this.getActiveOrganisation()}
                activeOrganisationId={this.props.organisations?.activeOrganisationId}
                activeAppSpace={this.getActiveAppSpace()}
                activeAppSpaceId={this.props.organisations?.activeAppSpaceId}
                activeTenant={this.getActiveTenant()}
                activeTenantId={this.props.tenants?.activeTenantId}
                isOrganisationSelected={isFull(this.props.organisations?.activeOrganisationId)}
                isAppSpaceSelected={isFull(this.props.organisations?.activeAppSpaceId)}
                organisationList={this.getOrganisations()}
                tenantList={this.getTenants()}
                canUserPerform={(x) => this.canUserPerform(x)}
                canUserPerformAny={(x) => this.canUserPerformAny(x)}
                {...this.props} />
        }
    };

    const mapStateToProps = (state) => ({
        organisations: state.entities.organisations,
        tenants: state.entities.tenants
    });

    const mapDispatchToProps = (dispatch) => ({
        setActiveAppSpaceId: (appSpaceId) => dispatch(setActiveAppSpaceId(appSpaceId)),
        setActiveOrganisationId: (orgId) => dispatch(setActiveOrganisationId(orgId)),
        setActiveTenantId: (tenantId) => dispatch(setActiveTenantId(tenantId))
    });

    return connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(WithAuth(WithOrganisationsHoC, options))
}